import { Pipe, PipeTransform } from "@angular/core";

import { simpleCompare } from "../../../../utils/base.util";

@Pipe({
  name: "hasActive",
})
export class HasActivePipe implements PipeTransform {
  transform(value: any, selectedValue: any[]): boolean {
    const option = (selectedValue || []).find(el => simpleCompare(el, value));
    return Boolean(option);
  }
}
